import React from "react";
import "../../../css/DesignSystem/Cards/PortalCard.css";
import "../../../css/App.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PortalCard = ({
  Icon,
  title,
  link,
  isAdviser = false,
  onClick = () => {},
  style,
  titleStyle,
}) => {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <button
        className={`PortalCard ${isAdviser ? "Adviser" : ""}  ${
          clicked ? "clicked" : ""
        }`}
        onClick={() => {
          onClick();
          setClicked(!clicked);
          navigate(link);
          // console.log(link);
        }}
        style={style}
      >
        {/* <NewsIcon /> */}

        {Icon && <Icon />}
         {typeof title === "string" && title?.length > 55 ? (
          <div className="Content-Large">{title}</div>
        ) : (
          <>
            
            <h3 style={titleStyle}>{title}</h3>
            <h4 style={titleStyle}>{title}</h4>
          </>
        )}
      </button>
    </>
  );
};

export default PortalCard;
